import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { ComponentsModule } from "../../components/form-components.module";
import { RegisterComponent } from "./register.component";
import { HttpService } from "src/providers/http.service";
// import { AppRoutingModule } from "../app-routing.module";
import { RouterModule } from "@angular/router";

@NgModule({
    imports: [ ComponentsModule, RouterModule ],
    declarations: [RegisterComponent],
    providers: [ HttpService ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
  })

  export class RegisterModule {}
